export default function text(key) {
  if (!txts) { return key }
  if (!txts[key]) { return key }
  return txts[key]
}
